import { render, staticRenderFns } from "./xmgj.vue?vue&type=template&id=7e6db4da&scoped=true&"
import script from "./xmgj.vue?vue&type=script&lang=js&"
export * from "./xmgj.vue?vue&type=script&lang=js&"
import style0 from "./xmgj.vue?vue&type=style&index=0&id=7e6db4da&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e6db4da",
  null
  
)

export default component.exports